// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner-bLTkq","icon":"icon-3m_km","viewOffers":"viewOffers-1ysdT","arrow":"arrow-2AQfd"};